import { render, staticRenderFns } from "./ExamTotalsCard.vue?vue&type=template&id=64acf8a3&scoped=true"
import script from "./ExamTotalsCard.vue?vue&type=script&lang=js"
export * from "./ExamTotalsCard.vue?vue&type=script&lang=js"
import style0 from "./ExamTotalsCard.vue?vue&type=style&index=0&id=64acf8a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64acf8a3",
  null
  
)

export default component.exports